import { Component, OnInit, TemplateRef } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ProfessionalService } from '../../services/professional.service';
import { DatePipe } from '@angular/common';
import { EncrDecrService } from './../../services/encr-decr.service';
import { Router, ActivatedRoute } from '@angular/router';
import * as XLSX from 'xlsx';

import { SoaImageService } from './../../services/soa-image.service';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { FilterPipe } from '../../_pipe/filter.pipe';
declare var $: any;
@Component({
    selector: 'app-importmodel',
    templateUrl: './importmodel.component.html',
    styleUrls: ['./importmodel.component.css']
})

export class ImportmodelComponent implements OnInit {
    modalRef: any = BsModalRef;
    config: any = {
        animated: true,
        keyboard: false,
        backdrop: true,
        ignoreBackdropClick: true
    };
    isExcelFile: boolean;
    file: any;
    arrayBuffer: any;
    filelist: any;
    folderid: any;
    folder_id_e: any;
    folderid_encrypt: any;
    showdiv: boolean = false;
    APIKEY: any;
    user_id: string;
    company_id: string;
    abc: string;
    currentUserRole: string;
    professionalData: any;
    professionalList: any = [];
    customer_id: string;
    myItems: any;
    totalRecord: any = 0;
    totalErrors: any = 0;
    totalRecordImported: any = 0;
    countErrorEmpid: any = 0;
    countErrorDepart: any = 0;
    addedprofessional: any = [];
    disableUploadBtn: boolean = false;
    disableCreateProfBtn: boolean = false;
    showFinalSubmitBtn: boolean = false;
    showdivcreatepro: boolean = false;
    loaderMode: boolean = false;
    professionalListImport: any = [];
    display: any = 'none';
    changestatusvar: boolean = false;
    MobNumber: any;
    showCreateProf: boolean = false;
    listdata: any = [];
    xlsxCellName: any = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'AA', 'AB', 'AC', 'AD', 'AE', 'AF'];
    select_field_array: any;
    fieldrecodes: any = [];
    selected_array: any = [];
    btnDisableForMapping: boolean = true;
    public temp_var: Object = true;
    checkarray: any = [];
    showCustomerName: any;
    datajsonForTemplate: any;
    changetemplate: boolean = false;
    checkArrayStatus: boolean;
    existingTemplate: any;
    isErorr: boolean = false;
    tableRowCount: any = 0;
    rowBoxErrorMsg: string = '';

    constructor(
        private toastr: ToastrService,
        private _router: Router,
        private _activatedroute: ActivatedRoute,
        private datePipe: DatePipe,
        private EncrDecr: EncrDecrService, public fb: FormBuilder,
        private _professional: ProfessionalService,
        private _soaImage: SoaImageService,
        private modalService: BsModalService,
    ) { }

    oppoSuitsForm = this.fb.group({
        name: ['Select']
    })

    ngOnInit() {
        this.user_id = localStorage.getItem('id');
        this.company_id = localStorage.getItem('company_id');
        this.APIKEY = localStorage.getItem('APIKEY');
        this.MobNumber = localStorage.getItem('MobNumber');
        this.customer_id = localStorage.getItem('customer_id');
        this.abc = localStorage.getItem('currentUser');
        var obj = JSON.parse(this.abc);
        this.currentUserRole = localStorage.getItem('role_name');
        this._activatedroute.params.subscribe(params => {
            this.folderid = this.EncrDecr.get(localStorage.getItem('key'), params['id']);
            this.folder_id_e = params['id'];
        });
        this.getFolderInfo(this.folderid);
        var tempa = ["Select", "Unknown", "Date Work Week", "Professional ID", "Name", "Speciality", "Reg Hrs", "OT Hrs", "DT Hrs", "Reg Cost Rate", "Reg Sale Rate", "OT Cost Rate", "OT Sale Rate", "DT Cost Rate", "DT Sale Rate", "Note"];
        var tempb = ["Select", "Unknown", "Date Work Week", "Professional ID", "Name", "Speciality", "Reg Hrs", "OT Hrs", "DT Hrs", "Reg Cost Rate", "Reg Sale Rate", "OT Cost Rate", "OT Sale Rate", "DT Cost Rate", "DT Sale Rate", "Note"];
        var mergedArray: any = tempa.map((e, i) => [e, tempb[i]]);
        this.listdata = mergedArray;
    }

    //on file inout click hide all div and buttons
    hideAllDiv() {
        this.showdivcreatepro = false;
        this.showFinalSubmitBtn = false;
        this.showdiv = false;
    }

    //1. upload xlsx file and read data
    onFileSelected(event) {
        //hide all div and buttons
        this.showdivcreatepro = false;
        this.showFinalSubmitBtn = false;
        this.showdiv = false;
        if (event.target.files && event.target.files[0]) {
            this.isExcelFile = !!event.target.files[0].name.match(/(.xls|.xlsx)/)
            if (this.isExcelFile != true) {
                $("#inputFile").val('');
                this.toastr.error('Invaild File Format. Only Xlsx File Are Allowed!');
                return;
            } else {
                if (this.isExcelFile) {
                    this.file = event.target.files[0];
                    let fileReader = new FileReader();
                    fileReader.readAsArrayBuffer(this.file);
                    fileReader.onload = (e) => {
                        this.arrayBuffer = fileReader.result;
                        var data = new Uint8Array(this.arrayBuffer);
                        var arr = new Array();
                        for (var i = 0; i != data.length; ++i) arr[i] = String.fromCharCode(data[i]);
                        var bstr = arr.join("");
                        var workbook = XLSX.read(bstr, { type: "binary" });
                        var first_sheet_name = workbook.SheetNames[0];
                        var worksheet = workbook.Sheets[first_sheet_name];
                        var arraylist = XLSX.utils.sheet_to_json(worksheet, { raw: false });
                        //get xlsx sheet header row
                        const headers = this.get_header_row(worksheet);
                        this.checkHeadersMatch(headers);
                        this.fieldrecodes = headers;
                        this.filelist = [];
                        this.filelist = arraylist;
                        this.disableUploadBtn = false;
                    };
                }
            }
        }
    }

    //get headers name of xlsx sheet
    get_header_row(sheet) {
        var headers = [];
        var range = XLSX.utils.decode_range(sheet['!ref']);
        var C, R = range.s.r;
        // start in the first row
        // walk every column in the range
        for (C = range.s.c; C <= range.e.c; ++C) {
            var cell = sheet[XLSX.utils.encode_cell({ c: C, r: R })]

            /* find the cell in the first row */
            var hdr = "UNKNOWN " + C; // <-- replace with your desired default 
            if (cell && cell.t)
                hdr = XLSX.utils.format_cell(cell);

            headers.push(hdr);
        }
        return headers;
    }

    //2. show xlsx data in table format with matching data from main professional and product line db table
    showFileData(filelist: any, isRunShowDivFun, insertImportProfessionalIds) {
        this.loaderMode = true;
        this.totalRecord = filelist.length;
        console.log('filelist ', filelist);
        const professionaldata = {
            APIKEY: this.APIKEY,
            user_id: this.user_id,
            company_id: this.company_id,
            status: 'Active',
            customer_id: this.customer_id,
            mobnumber: this.MobNumber
        }

        // for intermediate table check professional added on 28/02/2023 by archanaa
        if (this.showFinalSubmitBtn == true) {
            // api for show professional list from import db table
            this._professional.getCustomerProfessionalListImport(professionaldata)
                .subscribe(
                    res => {
                        this.professionalList = res.data;
                        this.myItems = [];
                        var counttotalerror = 0; //count
                        var countflagempid = 0; //count
                        var countflagdepart = 0; //count
                        this.isErorr = false;
                        this.tableRowCount = 0;

                        // loop of xlsx data
                        filelist.forEach((element, key) => {
                            this.tableRowCount++;
                            element.errorempid = false;
                            element.errordepart = false;
                            element.errorreghrs = false;
                            element.errorothrs = false;
                            element.emptyRegCostRate = false;
                            element.emptyOtCostRate = false;
                            element.emptyDtCostRate = false;
                            element.existingRegRateEmpty = true;
                            element.existingOtRateEmpty = true;
                            element.existingDtRateEmpty = true;

                            element.Assignment_No = (element.Assignment_No) ? element.Assignment_No.trim() : '';
                            element.Department = (element.Department) ? element.Department.trim() : '';
                            //added by deepak on 26/june/23
                            element.Note = (element.Note) ? element.Note.trim() : '';

                            //check rates available or not
                            element.Avg_Bill_Rate = (element.Avg_Bill_Rate) ? parseFloat(element.Avg_Bill_Rate).toFixed(2) : '';
                            element.Avg_Pay_Rate = (element.Avg_Pay_Rate) ? parseFloat(element.Avg_Pay_Rate).toFixed(2) : '';
                            element.OT_Bill_Rate = (element.OT_Bill_Rate) ? parseFloat(element.OT_Bill_Rate).toFixed(2) : '';
                            element.OT_Pay_Rate = (element.OT_Pay_Rate) ? parseFloat(element.OT_Pay_Rate).toFixed(2) : '';
                            element.DT_Bill_Rate = (element.DT_Bill_Rate) ? parseFloat(element.DT_Bill_Rate).toFixed(2) : '';
                            element.DT_Pay_Rate = (element.DT_Pay_Rate) ? parseFloat(element.DT_Pay_Rate).toFixed(2) : '';

                            //check hrs available or not
                            const RegHrs = (element.Reg_Hrs) ? element.Reg_Hrs : '';
                            const OTHrs = (element.OT_Hrs) ? element.OT_Hrs : '';
                            const DTHrs = (element.DT_Hrs) ? element.DT_Hrs : '';

                            // loop of import professional data
                            this.professionalList.forEach(item => {
                                //check professional id of import db table and sheet's professional id data is match or not
                                if (item.pro_unique_id.toLowerCase() == element.Assignment_No.toLowerCase() && item.professional_id == insertImportProfessionalIds[key]) {
                                    let singleRowProductLine = [];

                                    for (var i = 0; i < item.product_line_items.length; i++) {
                                        //get array index number after split comma separated record
                                        item.product_line_items[i].reg_index = item.product_line_items[i].work_type.split(',').findIndex(wt => wt == 'Regular');

                                        item.product_line_items[i].ot_index = item.product_line_items[i].work_type.split(',').findIndex(wt => wt == 'Overtime');

                                        item.product_line_items[i].dt_index = item.product_line_items[i].work_type.split(',').findIndex(wt => wt == 'Double');

                                        //check Department of import db table and sheet's Department data is match or not
                                        if (item.product_line_items[i].speciality.toLowerCase() === element.Department.toLowerCase()) {
                                            element.existingRegRateEmpty = false;
                                            element.existingOtRateEmpty = false;
                                            element.existingDtRateEmpty = false;

                                            //error check for existing rates available or not,
                                            //empid and department both are 0, means both value is in DB
                                            if (item.product_line_items[i].reg_index === -1) {
                                                if (RegHrs != '' && element.Avg_Pay_Rate == '') {
                                                    element.emptyRegCostRate = true;
                                                } else {
                                                    element.emptyRegCostRate = false;
                                                }

                                                element.existingRegRateEmpty = true;
                                            }

                                            if (item.product_line_items[i].ot_index === -1) {
                                                if (OTHrs != '' && element.OT_Pay_Rate == '') {
                                                    element.emptyOtCostRate = true;
                                                } else {
                                                    element.emptyOtCostRate = false;
                                                }

                                                element.existingOtRateEmpty = true;
                                            }

                                            if (item.product_line_items[i].dt_index === -1) {
                                                if (DTHrs != '' && element.DT_Pay_Rate == '') {
                                                    element.emptyDtCostRate = true;
                                                } else {
                                                    element.emptyDtCostRate = false;
                                                }

                                                element.existingDtRateEmpty = true;
                                            }

                                            singleRowProductLine.push(item.product_line_items[i]);
                                            element.product_line_items = singleRowProductLine;
                                            element.rowBgColor = '#82e76f'; //light green
                                            this.myItems.push(element);
                                            return false;
                                        } //lineitem if condition close
                                    } //lineitem for condition close
                                } // item.pro_unique_id if condition close
                            }); // professionalList foreach loop close

                            element.Date_w_e = this.datePipe.transform(element.Date_w_e, 'yyyy-MM-dd');

                        }); // professionalList foreach loop close

                        this.totalErrors = counttotalerror;
                        this.totalRecordImported = this.myItems.filter(entry => entry.error === 0).length;
                        this.countErrorEmpid = countflagempid;
                        this.countErrorDepart = countflagdepart;

                        //check after click on confirm button from mapping popup
                        if (isRunShowDivFun === true) {
                            this.showDivList(this.myItems);
                        }
                        this.loaderMode = false;
                    }, err => {
                        this.loaderMode = false;
                        console.log(err);
                    }
                );
            // code end
        } else {
            // api for get professional list from main professional db table
            this._professional.getMainProfessionalListForImport(professionaldata)
                .subscribe(
                    res => {
                        this.professionalList = res.data;
                        this.myItems = [];
                        this.isErorr = false;
                        this.tableRowCount = 0;

                        var flag = 0; //false
                        var counttotalerror = 0; //count

                        var flagempid = 1; //true
                        var countflagempid = 0; //count

                        var flagdepart = 1; //true
                        var countflagdepart = 0; //count

                        //var flagexistingrates = 0; //false
                        var flaghrs = 1; //true
                        //var flagreghrs = 0; //false
                        //var flagothrs = 0; //false
                        //var flagdthrs = 0; //false
                        var flagregmin = 0; //false
                        var flagregsec = 0; //false
                        var flagotmin = 0; //false
                        var flagotsec = 0; //false
                        var flagdtmin = 0; //false
                        var flagdtsec = 0; //false

                        // loop of xlsx data
                        filelist.forEach((element, key) => {
                            this.tableRowCount++;
                            element.departBgColor = '#ffa500'; //orange

                            element.errorempid = false;
                            element.errordepart = false;
                            element.errorreghrs = false;
                            element.errorothrs = false;
                            element.errordthrs = false;

                            element.emptyRegCostRate = false;
                            element.emptyRegSaleRate = false;
                            element.emptyOtCostRate = false;
                            element.emptyOtSaleRate = false;
                            element.emptyDtCostRate = false;
                            element.emptyDtSaleRate = false;

                            element.existingRegCostRateValue = '';
                            element.existingRegSaleRateValue = '';
                            element.existingOtCostRateValue = '';
                            element.existingOtSaleRateValue = '';
                            element.existingDtCostRateValue = '';
                            element.existingDtSaleRateValue = '';

                            element.existingRegRateEmpty = true; //true = rate is not available means empty
                            element.existingOtRateEmpty = true;
                            element.existingDtRateEmpty = true;

                            //check Assignment_No and Department available or not
                            const Assignment_No = (element.Assignment_No) ? element.Assignment_No.trim() : '';
                            const Department = (element.Department) ? element.Department.trim() : '';

                            //added by deepak on 26/june/23
                            element.Note = (element.Note) ? element.Note.trim() : '';
                            console.log('element.Note ', element.Note);

                            //check rates available or not
                            element.Avg_Bill_Rate = (element.Avg_Bill_Rate) ? parseFloat(element.Avg_Bill_Rate).toFixed(2) : '';
                            element.Avg_Pay_Rate = (element.Avg_Pay_Rate) ? parseFloat(element.Avg_Pay_Rate).toFixed(2) : '';
                            element.OT_Bill_Rate = (element.OT_Bill_Rate) ? parseFloat(element.OT_Bill_Rate).toFixed(2) : '';
                            element.OT_Pay_Rate = (element.OT_Pay_Rate) ? parseFloat(element.OT_Pay_Rate).toFixed(2) : '';
                            element.DT_Bill_Rate = (element.DT_Bill_Rate) ? parseFloat(element.DT_Bill_Rate).toFixed(2) : '';
                            element.DT_Pay_Rate = (element.DT_Pay_Rate) ? parseFloat(element.DT_Pay_Rate).toFixed(2) : '';

                            //check for hrs validation
                            const RegHrs = (element.Reg_Hrs) ? element.Reg_Hrs : '';
                            const OTHrs = (element.OT_Hrs) ? element.OT_Hrs : '';
                            const DTHrs = (element.DT_Hrs) ? element.DT_Hrs : '';

                            flaghrs = 1; //true
                            //flagreghrs = 0 ; //false
                            if (RegHrs != '') {
                                flaghrs = 0; //false
                                //if condition for check reg hrs have value like 10:23:34
                                if (RegHrs.includes(':')) {
                                    if (RegHrs.split(':')[1] > '59') {
                                        flagregmin = 1; //true
                                    }
                                    if (RegHrs.split(':')[2] > '59') {
                                        flagregsec = 1; //true
                                    }
                                }
                            }

                            //flagothrs = 0; //false
                            if (OTHrs != '') {
                                flaghrs = 0; //false
                                //if condition for check ot hrs have value like 10:23:34
                                if (OTHrs.includes(':')) {
                                    if (OTHrs.split(':')[1] > '59') {
                                        flagotmin = 1; //true
                                    }
                                    if (OTHrs.split(':')[2] > '59') {
                                        flagotsec = 1; //true
                                    }
                                }
                            }

                            //flagdthrs = 0; //false
                            if (DTHrs != '') {
                                //if condition for check dt hrs have value like 10:23:34
                                if (DTHrs.includes(':')) {
                                    if (DTHrs.split(':')[1] > '59') {
                                        flagdtmin = 1; //true
                                    }
                                    if (DTHrs.split(':')[2] > '59') {
                                        flagdtsec = 1; //true
                                    }
                                }
                            }

                            //if condition for reg cost rate missing and sale rate have value
                            //if condition for reg sale rate missing
                            if (RegHrs == '' && element.Avg_Pay_Rate == '' && element.Avg_Bill_Rate == '') {
                                element.emptyRegSaleRate = false;
                                element.emptyRegCostRate = false;
                            }
                            else if (element.Avg_Pay_Rate != '') {
                                //0 se badi value
                                if ((element.Avg_Pay_Rate * 1 > 0) && (element.Avg_Bill_Rate == '' || element.Avg_Bill_Rate * 1 <= element.Avg_Pay_Rate * 1)) {
                                    element.emptyRegSaleRate = true;
                                }
                                if (element.Avg_Pay_Rate * 1 <= 0) {
                                    element.emptyRegCostRate = true;
                                }
                            }
                            else {
                                //Avg_Pay_Rate balnk aa rahi h
                                if (element.Avg_Bill_Rate == '' || element.Avg_Bill_Rate * 1 > 0) {
                                    element.emptyRegCostRate = true;
                                }
                                if (element.Avg_Bill_Rate != '' && element.Avg_Bill_Rate * 1 <= 0) {
                                    element.emptyRegSaleRate = true;
                                }
                            }

                            if (OTHrs == '' && element.OT_Pay_Rate == '' && element.OT_Bill_Rate == '') {
                                element.emptyOtSaleRate = false;
                                element.emptyOtCostRate = false;
                            }
                            else if (element.OT_Pay_Rate != '') {
                                //if condition for ot cost rate missing and sale rate have value 
                                if ((element.OT_Pay_Rate * 1 > 0) && (element.OT_Bill_Rate == '' || element.OT_Bill_Rate * 1 <= element.OT_Pay_Rate * 1)) {
                                    element.emptyOtSaleRate = true;
                                }
                                if (element.OT_Pay_Rate * 1 <= 0) {
                                    element.emptyOtCostRate = true;
                                }
                            } else {
                                //OT_Pay_Rate balnk aa rahi h
                                if (element.OT_Bill_Rate == '' || element.OT_Bill_Rate * 1 > 0) {
                                    element.emptyOtCostRate = true;
                                }
                                if (element.OT_Bill_Rate != '' && element.OT_Bill_Rate * 1 <= 0) {
                                    element.emptyOtSaleRate = true;
                                }
                            }

                            if (DTHrs == '' && element.DT_Pay_Rate == '' && element.DT_Bill_Rate == '') {
                                //console.log('DTHrs nahi h ', DTHrs) ;
                                element.emptyDtSaleRate = false;
                                element.emptyDtCostRate = false;
                            }
                            else if (element.DT_Pay_Rate != '') {
                                //console.log('DTHrs h ', DTHrs) ;
                                //if condition for ot cost rate missing and sale rate have value 
                                if ((element.DT_Pay_Rate * 1 > 0) && (element.DT_Bill_Rate == '' || element.DT_Bill_Rate * 1 <= element.DT_Pay_Rate * 1)) {
                                    element.emptyDtSaleRate = true;
                                    //console.log('DT_Bill_Rate balnk or 0 h ',element.DT_Bill_Rate) ;
                                }
                                if (element.DT_Pay_Rate * 1 <= 0) {
                                    element.emptyDtCostRate = true;
                                    //console.log('DT_Pay_Rate 0 h ',element.DT_Pay_Rate) ;   
                                }
                            } else {
                                //console.log('DTHrs h ', DTHrs) ;
                                //DT_Pay_Rate balnk aa rahi h
                                //console.log('DT_Pay_Rate blank h') ;
                                if (element.DT_Bill_Rate == '' || element.DT_Bill_Rate * 1 > 0) {
                                    element.emptyDtCostRate = true;
                                    //console.log('condition 0 if DT_Bill_Rate ==0 ',(element.DT_Bill_Rate=='')) ;
                                }
                                if (element.DT_Bill_Rate != '' && element.DT_Bill_Rate * 1 <= 0) {
                                    element.emptyDtSaleRate = true;
                                    //console.log('condition 2 else DT_Bill_Rate == 0 ',(element.DT_Bill_Rate*1<=0)) ;
                                }
                            }

                            // loop of main professional data
                            this.professionalList.forEach(item => {
                                //check professional id of main db table and sheet's professional id data is match or not
                                //console.log('item.pro_unique_id ',item.pro_unique_id) ;
                                //console.log('Assignment_No ',Assignment_No) ;
                                if (item.pro_unique_id.toLowerCase() === Assignment_No.toLowerCase()) {
                                    flagempid = 0; //false
                                    element.professional_id = item.professional_id;

                                    let singleRowProductLine = [];
                                    let allRowProductLine = [];

                                    for (var i = 0; i < item.product_line_items.length; i++) {
                                        //get array index number after split comma separated record
                                        item.product_line_items[i].reg_index = item.product_line_items[i].work_type.split(',').findIndex(wt => wt == 'Regular');

                                        item.product_line_items[i].ot_index = item.product_line_items[i].work_type.split(',').findIndex(wt => wt == 'Overtime');

                                        item.product_line_items[i].dt_index = item.product_line_items[i].work_type.split(',').findIndex(wt => wt == 'Double');

                                        //console.log('item.speciality ',item.product_line_items[i].speciality) ;
                                        //console.log('Department ',Department) ;
                                        //check Department of main db table and sheet's Department data is match or not
                                        if (item.product_line_items[i].speciality.toLowerCase() === Department.toLowerCase()) {
                                            // console.log(item.product_line_items[i].speciality,' Department match kar raha h') ;

                                            console.log('product_line_items[' + i + '].reg_index ' + key, item.product_line_items[i].reg_index);
                                            console.log('product_line_items[' + i + '].ot_index ' + key, item.product_line_items[i].ot_index);
                                            console.log('product_line_items[' + i + '].dt_index ' + key, item.product_line_items[i].dt_index);

                                            flag = 1;
                                            flagdepart = 0; //false
                                            element.departBgColor = '#ffffff'; //white
                                            element.existingRegRateEmpty = false; //false = rate is available
                                            element.existingOtRateEmpty = false;
                                            element.existingDtRateEmpty = false;

                                            //error check for existing rates available or not,
                                            //empid and department both are 0, means both value is in DB
                                            //-1 means reg rate not available
                                            console.log('Avg_Pay_Rate ' + key, element.Avg_Pay_Rate);
                                            console.log('Avg_Bill_Rate ' + key, element.Avg_Bill_Rate);
                                            if (item.product_line_items[i].reg_index === -1) {
                                                element.existingRegRateEmpty = true; //true = rate is not available
                                            } else {
                                                //this is for check sheet rates from existing rates
                                                element.existingRegCostRateValue = item.product_line_items[i].cost_rate.split(',')[item.product_line_items[i].reg_index];
                                                element.existingRegSaleRateValue = item.product_line_items[i].sale_rate.split(',')[item.product_line_items[i].reg_index];

                                                //if condition for reg cost rate is missing & existing cost rate greater than sheet's sale rate 

                                                if (element.Avg_Pay_Rate == '' || element.Avg_Bill_Rate == '') {
                                                    element.emptyRegCostRate = false;
                                                    element.emptyRegSaleRate = false;

                                                    console.log('Avg_Pay_Rate or Avg_Bill_Rate me se kisi ek me value h or dono he blank h ' + key);

                                                    //if Avg_Pay_Rate have value
                                                    // 2 > 0 && '' && 100<=2 t t f 
                                                    if (element.Avg_Pay_Rate * 1 > 0 && element.Avg_Bill_Rate == '' && item.product_line_items[i].sale_rate.split(',')[item.product_line_items[i].reg_index] * 1 <= element.Avg_Pay_Rate * 1) {
                                                        element.emptyRegSaleRate = true;
                                                        console.log('condition 1 Avg_Bill_Rate balnk h ' + key);
                                                    }
                                                    // 2 > 0 && (!= && 0>=0) && 0<=2 t t t
                                                    // 2 > 0 && (!= && 1>=0) && 1<=2 t t t
                                                    if (element.Avg_Pay_Rate * 1 > 0 && (element.Avg_Bill_Rate != '' && element.Avg_Bill_Rate * 1 >= 0) && element.Avg_Bill_Rate * 1 <= element.Avg_Pay_Rate * 1) {
                                                        element.emptyRegSaleRate = true;
                                                        console.log('condition 2 Avg_Bill_Rate me 0 or negative h ' + key);
                                                    }

                                                    //if Avg_Bill_Rate have value
                                                    // 2 > 0 && '' && 2<=50 t t t
                                                    if (element.Avg_Bill_Rate * 1 > 0 && element.Avg_Pay_Rate == '' && element.Avg_Bill_Rate * 1 <= item.product_line_items[i].cost_rate.split(',')[item.product_line_items[i].reg_index] * 1) {
                                                        element.emptyRegSaleRate = true;
                                                        console.log('condition 3 Avg_Bill_Rate existine cost rate se chota h ' + key);
                                                    }
                                                    // 2 > 0 && (!= && 0>=0) && 2<=0 t t t
                                                    // 2 > 0 && (!= && 1>=0) && 2<=1 t t t
                                                    if (element.Avg_Bill_Rate * 1 > 0 && (element.Avg_Pay_Rate != '' && element.Avg_Pay_Rate * 1 >= 0) && element.Avg_Bill_Rate * 1 <= element.Avg_Pay_Rate * 1) {
                                                        element.emptyRegCostRate = true;
                                                        console.log('condition 4 Avg_Pay_Rate me 0 or negative h ' + key);
                                                    }

                                                    //0 > 0
                                                    if ((element.Avg_Pay_Rate != '' && element.Avg_Pay_Rate * 1 <= 0) && element.Avg_Bill_Rate == '') {
                                                        element.emptyRegCostRate = true;
                                                        console.log('condition 5 Avg_Pay_Rate 0  h ' + key);
                                                    }

                                                    // console.log('condition 6-0 '+key, (element.Avg_Bill_Rate!=''&&element.Avg_Bill_Rate*1<=0)) ;
                                                    // console.log('condition 6-1 '+key, element.Avg_Pay_Rate=='') ;
                                                    if ((element.Avg_Bill_Rate != '' && element.Avg_Bill_Rate * 1 <= 0) && element.Avg_Pay_Rate == '') {
                                                        element.emptyRegSaleRate = true;
                                                        console.log('condition 6 Avg_Bill_Rate 0  h ' + key);
                                                    }
                                                }
                                            }

                                            //if ot rate not available
                                            if (item.product_line_items[i].ot_index === -1) {
                                                element.existingOtRateEmpty = true;
                                            } else {

                                                //this is for check sheet rates from existing rates
                                                element.existingOtCostRateValue = item.product_line_items[i].cost_rate.split(',')[item.product_line_items[i].ot_index];
                                                element.existingOtSaleRateValue = item.product_line_items[i].sale_rate.split(',')[item.product_line_items[i].ot_index];

                                                if (element.OT_Pay_Rate == '' || element.OT_Bill_Rate == '') {
                                                    element.emptyOtCostRate = false;
                                                    element.emptyOtSaleRate = false;

                                                    // console.log('OT_Pay_Rate or OT_Bill_Rate me se kisi ek me value h or dono he blank h',element.OT_Pay_Rate+'-'+element.OT_Bill_Rate) ;

                                                    //if OT_Pay_Rate have value
                                                    // 2 > 0 && '' && 100<=2 t t f 
                                                    if (element.OT_Pay_Rate * 1 > 0 && element.OT_Bill_Rate == '' && item.product_line_items[i].sale_rate.split(',')[item.product_line_items[i].reg_index] * 1 <= element.OT_Pay_Rate * 1) {
                                                        element.emptyOtSaleRate = true;
                                                        // console.log('condition 1 OT_Bill_Rate balnk h ',element.OT_Bill_Rate) ;
                                                    }
                                                    // 2 > 0 && (!= && 0>=0) && 0<=2 t t t
                                                    // 2 > 0 && (!= && 1>=0) && 1<=2 t t t
                                                    if (element.OT_Pay_Rate * 1 > 0 && (element.OT_Bill_Rate != '' && element.OT_Bill_Rate * 1 >= 0) && element.OT_Bill_Rate * 1 <= element.OT_Pay_Rate * 1) {
                                                        element.emptyOtSaleRate = true;
                                                        // console.log('condition 2 OT_Bill_Rate me 0 or negative h ',element.OT_Bill_Rate) ;
                                                    }

                                                    //if OT_Bill_Rate have value
                                                    // 2 > 0 && '' && 2<=50 t t t
                                                    if (element.OT_Bill_Rate * 1 > 0 && element.OT_Pay_Rate == '' && element.OT_Bill_Rate * 1 <= item.product_line_items[i].cost_rate.split(',')[item.product_line_items[i].reg_index] * 1) {
                                                        element.emptyOtSaleRate = true;
                                                        //   console.log('condition 3 OT_Bill_Rate existine cost rate se chota h ',element.OT_Bill_Rate) ;
                                                    }
                                                    // 2 > 0 && (!= && 0>=0) && 2<=0 t t t
                                                    // 2 > 0 && (!= && 1>=0) && 2<=1 t t t
                                                    if (element.OT_Bill_Rate * 1 > 0 && (element.OT_Pay_Rate != '' && element.OT_Pay_Rate * 1 >= 0) && element.OT_Bill_Rate * 1 <= element.OT_Pay_Rate * 1) {
                                                        element.emptyOtCostRate = true;
                                                        //  console.log('condition 4 OT_Pay_Rate me 0 or negative h ',element.OT_Bill_Rate) ;
                                                    }

                                                    if ((element.OT_Pay_Rate != '' && element.OT_Pay_Rate * 1 <= 0) && element.OT_Bill_Rate == '') {
                                                        element.emptyOtCostRate = true;
                                                        console.log('condition 5 OT_Pay_Rate 0  h ' + key);
                                                    }

                                                    if ((element.OT_Bill_Rate != '' && element.OT_Bill_Rate * 1 <= 0) && element.OT_Pay_Rate == '') {
                                                        element.emptyOtSaleRate = true;
                                                        console.log('condition 6 OT_Bill_Rate 0  h ' + key);
                                                    }
                                                }
                                            }

                                            // console.log('DT_Pay_Rate existing ',element.DT_Pay_Rate) ;
                                            // console.log('DT_Bill_Rate existing ',element.DT_Bill_Rate) ;
                                            //if dt rate not available
                                            if (item.product_line_items[i].dt_index === -1) {
                                                element.existingDtRateEmpty = true;
                                            } else {

                                                //this is for check sheet rates from existing rates
                                                element.existingDtCostRateValue = item.product_line_items[i].cost_rate.split(',')[item.product_line_items[i].dt_index];
                                                element.existingDtSaleRateValue = item.product_line_items[i].sale_rate.split(',')[item.product_line_items[i].dt_index];

                                                if (element.DT_Pay_Rate == '' || element.DT_Bill_Rate == '') {
                                                    element.emptyDtCostRate = false;
                                                    element.emptyDtSaleRate = false;

                                                    //  console.log('DT_Pay_Rate or DT_Bill_Rate me se kisi ek me value h or dono he blank h',element.DT_Pay_Rate+'-'+element.DT_Bill_Rate) ;

                                                    //if DT_Pay_Rate have value
                                                    // 2 > 0 && '' && 100<=2 t t f 
                                                    if (element.DT_Pay_Rate * 1 > 0 && element.DT_Bill_Rate == '' && item.product_line_items[i].sale_rate.split(',')[item.product_line_items[i].reg_index] * 1 <= element.DT_Pay_Rate * 1) {
                                                        element.emptyDtSaleRate = true;
                                                        //   console.log('condition 1 DT_Bill_Rate balnk h ',element.DT_Bill_Rate) ;
                                                    }
                                                    // 2 > 0 && (!= && 0>=0) && 0<=2 t t t
                                                    // 2 > 0 && (!= && 1>=0) && 1<=2 t t t
                                                    if (element.DT_Pay_Rate * 1 > 0 && (element.DT_Bill_Rate != '' && element.DT_Bill_Rate * 1 >= 0) && element.DT_Bill_Rate * 1 <= element.DT_Pay_Rate * 1) {
                                                        element.emptyDtSaleRate = true;
                                                        //   console.log('condition 2 DT_Bill_Rate me 0 or negative h ',element.DT_Bill_Rate) ;
                                                    }

                                                    //if DT_Bill_Rate have value
                                                    // 2 > 0 && '' && 2<=50 t t t
                                                    if (element.DT_Bill_Rate * 1 > 0 && element.DT_Pay_Rate == '' && element.DT_Bill_Rate * 1 <= item.product_line_items[i].cost_rate.split(',')[item.product_line_items[i].reg_index] * 1) {
                                                        element.emptyDtSaleRate = true;
                                                        //    console.log('condition 3 DT_Bill_Rate existine cost rate se chota h ',element.DT_Bill_Rate) ;
                                                    }
                                                    // 2 > 0 && (!= && 0>=0) && 2<=0 t t t
                                                    // 2 > 0 && (!= && 1>=0) && 2<=1 t t t
                                                    if (element.DT_Bill_Rate * 1 > 0 && (element.DT_Pay_Rate != '' && element.DT_Pay_Rate * 1 >= 0) && element.DT_Bill_Rate * 1 <= element.DT_Pay_Rate * 1) {
                                                        element.emptyDtCostRate = true;
                                                        //    console.log('condition 4 DT_Pay_Rate me 0 or negative h ',element.DT_Bill_Rate) ;
                                                    }

                                                    if ((element.DT_Pay_Rate != '' && element.DT_Pay_Rate * 1 <= 0) && element.DT_Bill_Rate == '') {
                                                        element.emptyDtCostRate = true;
                                                        console.log('condition 5 DT_Pay_Rate 0  h ' + key);
                                                    }

                                                    if ((element.DT_Bill_Rate != '' && element.DT_Bill_Rate * 1 <= 0) && element.DT_Pay_Rate == '') {
                                                        element.emptyDtSaleRate = true;
                                                        console.log('condition 6 DT_Bill_Rate 0  h ' + key);
                                                    }
                                                }
                                            }

                                            //if department/speciality is match from main table, so push single record from product line db table
                                            singleRowProductLine.push(item.product_line_items[i]);
                                            element.product_line_items = singleRowProductLine;
                                            element.rowBgColor = '#82e76f'; //light green
                                            this.myItems.push(element);
                                            return false;
                                        } //lineitem if condition close
                                        else {
                                            flagdepart = 1; //true
                                            element.departBgColor = '#87ceeb'; //sky blue
                                            //if department/speciality is not match from main table, so push all main department data from product line db table 
                                            allRowProductLine.push(item.product_line_items[i]);
                                            element.product_line_items = allRowProductLine;
                                            element.rowBgColor = '#82e76f'; //light green
                                        }
                                    } //lineitem for condition close
                                } // item.pro_unique_id if condition close  
                            }); // professionalList foreach loop close

                            // error check for sheet hrs and rates
                            if (flaghrs == 1) {
                                element.errorreghrs = true;
                                element.errorothrs = true;
                                this.showCreateProf = true;
                                this.isErorr = true;
                                this.rowBoxErrorMsg = "<span style='font-size: 24px !important;'>Please Enter Value On Reg Hrs or OT Hrs</span>";
                            } else {
                                // console.log('flagempid ',flagempid) ;
                                // console.log('flagdepart ',flagdepart) ;
                                this.showCreateProf = true;

                                if (flagregmin == 1) {
                                    element.errorreghrs = true;
                                    this.isErorr = true;
                                    this.rowBoxErrorMsg = "<span style='font-size: 24px !important;'>Reg Hrs Minute Can Not Be Greater Than 59 Minute</span>";
                                }
                                if (flagregsec == 1) {
                                    element.errorreghrs = true;
                                    this.isErorr = true;
                                    this.rowBoxErrorMsg = "<span style='font-size: 24px !important;'>Reg Hrs Second Can Not Be Greater Than 59 Second</span>";
                                }
                                if (flagotmin == 1) {
                                    element.errorothrs = true;
                                    this.isErorr = true;
                                    this.rowBoxErrorMsg = "<span style='font-size: 24px !important;'>Ot Hrs Minute Can Not Be Greater Than 59 Minute</span>";
                                }
                                if (flagotsec == 1) {
                                    element.errorothrs = true;
                                    this.isErorr = true;
                                    this.rowBoxErrorMsg = "<span style='font-size: 24px !important;'>Ot Hrs Second Can Not Be Greater Than 59 Second</span>";
                                }
                                if (flagdtmin == 1) {
                                    element.errordthrs = true;
                                    this.isErorr = true;
                                    this.rowBoxErrorMsg = "<span style='font-size: 24px !important;'>Dt Hrs Minute Can Not Be Greater Than 59 Minute</span>";
                                }
                                if (flagdtsec == 1) {
                                    element.errordthrs = true;
                                    this.isErorr = true;
                                    this.rowBoxErrorMsg = "<span style='font-size: 24px !important;'>Dt Hrs Second Can Not Be Greater Than 59 Second</span>";
                                }
                            }

                            //error check for rates
                            if (element.emptyRegCostRate == true || element.emptyRegSaleRate == true || element.emptyOtCostRate == true || element.emptyOtSaleRate == true || element.emptyDtCostRate == true || element.emptyDtSaleRate == true) {
                                //console.log('sale rate or cost rate nahi hhhhhh') ;
                                this.showCreateProf = true;
                                this.isErorr = true;
                                this.rowBoxErrorMsg = "<span style='font-size: 24px !important;'>Either The Rates Are Missing or Sale Rate Is Less Than or Equal To The Cost Rate</span>";
                            }

                            element.Date_w_e = this.datePipe.transform(element.Date_w_e, 'yyyy-MM-dd');

                            // error check for all
                            // if flag value is 0 so if condition will work
                            //console.log('flag end ',flag) ;
                            if (flag != 1) {
                                // console.log('flag if deepak',flag) ;
                                counttotalerror++;
                                if (flagempid == 1) {
                                    element.errorempid = true;
                                    this.showCreateProf = true;
                                    if (Assignment_No == '') {
                                        this.isErorr = true;
                                        this.rowBoxErrorMsg = "<span style='font-size: 24px !important;'>Please Enter Value On Professional Id</span>";
                                    }
                                }
                                if (flagdepart == 1) {
                                    element.errordepart = true;
                                    this.showCreateProf = true;
                                    if (Department == '') {
                                        this.isErorr = true;
                                        this.rowBoxErrorMsg = "<span style='font-size: 24px !important;'>Please Enter Value On Speciality</span>";
                                    }
                                }

                                this.myItems.push(element);
                            }
                            else {
                                // console.log('flag else deepak ',flag) ;
                                flag = 0;
                            }

                            if (flagempid == 1) {
                                countflagempid++;
                                //this.employeeidArray.push(element);
                            } else {
                                flagempid = 1;
                            }
                            if (flagdepart == 1) {
                                countflagdepart++;
                                //this.departmentArray.push(element);
                            } else {
                                flagdepart = 1;
                            }

                        }); // filelist foreach loop close

                        // console.log('this.showCreateProf ',this.showCreateProf) ;
                        // console.log('this.isErorr ',this.isErorr) ;
                        // console.log('myItems ',this.myItems) ;
                        this.totalErrors = counttotalerror;
                        this.totalRecordImported = this.myItems.filter(entry => entry.error === 0).length;
                        this.countErrorEmpid = countflagempid;
                        this.countErrorDepart = countflagdepart;

                        //check after click on confirm button from mapping popup
                        if (isRunShowDivFun === true) {
                            this.showDivList(this.myItems);
                        }
                        this.loaderMode = false;
                    }, err => {
                        this.loaderMode = false;
                        console.log(err);
                    }
                );
            // code end
        }
    }

    //3. show xlsx data list and counts div and upload data into import tables
    showDivList(sheetData) {
        const inputFileValue = $("#inputFile").val();
        if (inputFileValue) {
            // this.loaderMode = true;
            // this.disableUploadBtn = true;
            // var professionalModal = {
            //     APIKEY: this.APIKEY,
            //     user_id: this.user_id,
            //     company_id: this.company_id,
            //     status: 'Active',
            //     customer_id: this.customer_id,
            //     professionalData: sheetData,
            //     mobnumber: this.MobNumber
            // };
            // this._professional.addProfessionalDataForXlsx(professionalModal)
            //     .subscribe(
            //         res => {
            //             if (res.status == true) {
            this.disableUploadBtn = false;
            if (this.showCreateProf === true) {
                this.showdivcreatepro = true;
                this.showFinalSubmitBtn = false;
            } else {
                this.showdivcreatepro = false;
                this.showFinalSubmitBtn = true;
            }
            this.showdiv = true;
            // Clear the input
            $("#inputFile").val('');
            this.loaderMode = false;
        }
        // }, err => {
        //     this.disableUploadBtn = false;
        //     $("#inputFile").val('');
        //     this.toastr.error('Internal Server Error Please Reupload File With Correct Data');
        //     console.log(err);
        // }
        // );

        // } else {
        //     this.toastr.error('Please Select Any Xlsx File');
        //     return;
        // }
    }

    //4. create professionals by insert data into intermediate professionals and product line db table
    addProfessionalDataForXlsx(data) {
        this.loaderMode = true;
        this.disableCreateProfBtn = true;
        this.disableUploadBtn = true;
        this.showFinalSubmitBtn = true;
        this.showdivcreatepro = false;
        var professionalModal = {
            APIKEY: this.APIKEY,
            user_id: this.user_id,
            company_id: this.company_id,
            status: 'Active',
            customer_id: this.customer_id,
            professionalData: data,
            mobnumber: this.MobNumber
        };
        this._professional.addProfessionalDataForXlsx(professionalModal)
            .subscribe(
                res => {
                    if (res['status'] == true) {
                        this.loaderMode = false;
                        this.showFileData(this.myItems, false, res['ids']); //isRunShowDivFun is false,res['ids']=insertImportProfessionalIds
                    } else {
                        this.loaderMode = false;
                    }

                    this.disableCreateProfBtn = false;
                    this.disableUploadBtn = false;
                }, err => {
                    this.loaderMode = false;
                    console.log(err);
                });
    }

    //this function call if change any value in table data. show swal window with Do you want to save any information message.
    onFinalSubmit() {
        this.loaderMode = true;
        const data = {
            APIKEY: this.APIKEY,
            user_id: this.user_id,
            company_id: this.company_id,
            status: 'Active',
            customer_id: this.customer_id,
            mobnumber: this.MobNumber
        };

        this._professional.getAndSaveProInfoForImport(data)
            .subscribe(
                res => {
                    if (res.status == true) {

                        this.loaderMode = false;
                        localStorage.setItem('importsuccess', 'true');
                        this._router.navigate(["/mobile/edit-mobile/" + this.folder_id_e]);
                    } else {

                        this.loaderMode = false;
                        this.toastr.error('Something went wrong');
                        return;
                    }
                }, err => {
                    this.loaderMode = false;
                    console.log(err);
                }
            );
    }

    //if change any value on data table
    changestatus($event) {
        if ($event != '') {
            this.changestatusvar = true;
            this.showdivcreatepro = true;
            this.disableCreateProfBtn = true;
            this.showFinalSubmitBtn = false;
        }
    }

    //if change any value on reg hrs or ot hrs
    changeRegHrs($event, index) {
        console.log('changeRegHrs', $event);
        if ($event != '') {
            //this function will run row wise
            var regCostRate = $("#regCostRate" + index);
            var regHrs = $("#regHrs" + index);

            if (regHrs.val() == '') {
                if ($("#otHrs" + index).val() == '') {
                    regHrs.css("background", "#fd5c63");
                    $("#otHrs" + index).css("background", "#fd5c63");
                }
                regCostRate.css("background", "");
            } else {
                regHrs.css("background", "");
                $("#otHrs" + index).css("background", "");
                $("#otCostRate" + index).css("background", "");
            }

            this.checkErrorInAllRow();
        }
    }

    changeOtHrs($event, index) {
        if ($event != '') {
            //this function will run row wise
            var otCostRate = $("#otCostRate" + index);
            var otHrs = $("#otHrs" + index);

            if (otHrs.val() == '') {
                if ($("#regHrs" + index).val() == '') {
                    $("#regHrs" + index).css("background", "#fd5c63");
                    otHrs.css("background", "#fd5c63");
                }
                otCostRate.css("background", "");
            } else {
                $("#regHrs" + index).css("background", "");
                otHrs.css("background", "");
                $("#regCostRate" + index).css("background", "");
            }

            this.checkErrorInAllRow();
        }
    }

    changeDtHrs($event, index) {
        if ($event != '') {
            //this function will run row wise
            var dtCostRate = $("#dtCostRate" + index);
            var dtHrs = $("#dtHrs" + index);

            if (dtHrs.val() == '') {
                console.log('dt hrs val remove kiya');
                dtCostRate.css("background", "");
                // if (dtCostRate.val() != '') {
                //     dtHrs.css("background", "#fd5c63");
                // }
            }
            // else {
            //     console.log('dt hrs val enter kiya') ;
            //     //dtHrs.css("background", "");
            // }

            this.checkErrorInAllRow();
        }
    }

    changeRegRate($event, index) {
        if ($event != '') {
            var regCostRate = $("#regCostRate" + index);
            var regHrs = $("#regHrs" + index);
            var regSaleRate = $("#regSaleRate" + index);

            if (regCostRate.val() == '') {
                if (regHrs.val() == '') {
                    regCostRate.css("background", "");
                }
            } else {
                regCostRate.css("background", "");
            }

            if (regSaleRate.val() == '') {
                if (regHrs.val() == '') {
                    regSaleRate.css("background", "");
                }
            } else {
                regSaleRate.css("background", "");
            }

            this.checkErrorInAllRow();
        }
    }

    changeOtRate($event, index) {
        if ($event != '') {
            var otCostRate = $("#otCostRate" + index);
            var otHrs = $("#otHrs" + index);
            var otSaleRate = $("#otSaleRate" + index);

            if (otCostRate.val() == '') {
                if (otHrs.val() == '') {
                    otCostRate.css("background", "");
                }
            } else {
                otCostRate.css("background", "");
            }

            if (otSaleRate.val() == '') {
                if (otHrs.val() == '') {
                    otSaleRate.css("background", "");
                }
            } else {
                otSaleRate.css("background", "");
            }

            this.checkErrorInAllRow();
        }
    }

    changeDtRate($event, index) {
        if ($event != '') {
            var dtCostRate = $("#dtCostRate" + index);
            var dtHrs = $("#dtHrs" + index);
            var dtSaleRate = $("#dtSaleRate" + index);

            if (dtCostRate.val() == '') {
                if (dtHrs.val() == '') {
                    dtCostRate.css("background", "");
                }
            } else {
                dtCostRate.css("background", "");
            }

            if (dtSaleRate.val() == '') {
                if (dtHrs.val() == '') {
                    dtSaleRate.css("background", "");
                }
            } else {
                dtSaleRate.css("background", "");
            }

            this.checkErrorInAllRow();
        }
    }

    changeEmptyField($event, index) {
        if ($event != '') {
            var getIdName = $event.target.id;
            var currentRowId = $("#" + getIdName);
            if (currentRowId.val() == '') {
                currentRowId.css("background", "#fd5c63");
            } else {
                currentRowId.css("background", "");
            }

            this.checkErrorInAllRow();
        }
    }

    checkErrorInAllRow() {
        this.isErorr = false;
        for (var i = 0; i < this.tableRowCount; i++) {
            if ($("#assiNo" + i).val() == '') {
                this.isErorr = true;
                this.rowBoxErrorMsg = "<span style='font-size: 24px !important;'>Please Enter Value On Professional Id</span>";
            }
            if ($("#dept" + i).val() == '') {
                this.isErorr = true;
                this.rowBoxErrorMsg = "<span style='font-size: 24px !important;'>Please Enter Value On Speciality</span>";
            }
            if ($("#regHrs" + i).val() == '' && $("#otHrs" + i).val() == '') {
                this.isErorr = true;
                this.rowBoxErrorMsg = "<span style='font-size: 24px !important;'>Please Enter Value On Reg Hrs or OT Hrs</span>";
            } else {
                var existingRegRateEmpty = $("#regCostRate" + i).data('existingregrateempty');
                var existingOtRateEmpty = $("#otCostRate" + i).data('existingotrateempty');
                var existingDtRateEmpty = $("#dtCostRate" + i).data('existingdtrateempty');
                var existingRegCostRateValue = $("#regCostRate" + i).data('existingregcostratevalue');
                var existingRegSaleRateValue = $("#regSaleRate" + i).data('existingregsaleratevalue');
                var existingOtCostRateValue = $("#otCostRate" + i).data('existingotcostratevalue');
                var existingOtSaleRateValue = $("#otSaleRate" + i).data('existingotsaleratevalue');
                var existingDtCostRateValue = $("#dtCostRate" + i).data('existingdtcostratevalue');
                var existingDtSaleRateValue = $("#dtSaleRate" + i).data('existingdtsaleratevalue');

                $("#regCostRate" + i).css("background", "");
                $("#regSaleRate" + i).css("background", "");
                //either sale rate or cost rate have value
                if ($("#regCostRate" + i).val() != '' || $("#regSaleRate" + i).val() != '') {
                    //true means existing rate is empty
                    if (existingRegRateEmpty == true) {
                        console.log('existing reg rate nahhhhhhhhhhhhi h');
                        //if reg cost rate is empty
                        // ('' || 0 <= 0) t
                        if ($("#regCostRate" + i).val() == '' || $("#regCostRate" + i).val() * 1 <= 0) {
                            console.log('condition 1 existing reg rate nahhhhhhhhhhhhi h');
                            this.isErorr = true;
                            $("#regCostRate" + i).css("background", "#fd5c63");
                            this.rowBoxErrorMsg = "<span style='font-size: 24px !important;'>Either The Rates Are Missing or Sale Rate Is Less Than or Equal To The Cost Rate</span>";
                        }

                        //if reg cost rate have value and sale rate is empty or sale rate is less than cost rate
                        // 2 && ('' || '' <= 2) t t
                        // 2 && (1 || 1 <= 2) t t
                        if (($("#regCostRate" + i).val() != '') && ($("#regSaleRate" + i).val() == '' || $("#regSaleRate" + i).val() * 1 <= $("#regCostRate" + i).val() * 1)) {
                            console.log('condition 2 existing reg rate nahhhhhhhhhhhhi h');
                            this.isErorr = true;
                            $("#regSaleRate" + i).css("background", "#fd5c63");
                            this.rowBoxErrorMsg = "<span style='font-size: 24px !important;'>Either The Rates Are Missing or Sale Rate Is Less Than or Equal To The Cost Rate</span>";
                        }
                    } else {
                        console.log('existing reg rate h');
                        //if reg cost rate have value and sale rate is empty and exiting sale rate is less than cost rate
                        // 0 != '' && '' && 100 <= 0
                        if ($("#regCostRate" + i).val() != '' && $("#regSaleRate" + i).val() == '' && existingRegSaleRateValue * 1 <= $("#regCostRate" + i).val() * 1) {
                            console.log('condition 1 existing reg rate h');
                            this.isErorr = true;
                            $("#regSaleRate" + i).css("background", "#fd5c63");
                            this.rowBoxErrorMsg = "<span style='font-size: 24px !important;'>Either The Rates Are Missing or Sale Rate Is Less Than or Equal To The Cost Rate</span>";
                        }

                        //if reg sale rate have value and cost rate is empty and sale rate is less than exiting cost rate
                        if ($("#regCostRate" + i).val() == '' && $("#regSaleRate" + i).val() != '' && $("#regSaleRate" + i).val() * 1 <= existingRegCostRateValue * 1) {
                            console.log('condition 2 existing reg rate h');
                            this.isErorr = true;
                            $("#regSaleRate" + i).css("background", "#fd5c63");
                            this.rowBoxErrorMsg = "<span style='font-size: 24px !important;'>Either The Rates Are Missing or Sale Rate Is Less Than or Equal To The Cost Rate</span>";
                        }

                        if ($("#regCostRate" + i).val() != '' && $("#regCostRate" + i).val() * 1 <= 0) {
                            console.log('condition 3 existing reg rate h');
                            this.isErorr = true;
                            $("#regCostRate" + i).css("background", "#fd5c63");
                            this.rowBoxErrorMsg = "<span style='font-size: 24px !important;'>Either The Rates Are Missing or Sale Rate Is Less Than or Equal To The Cost Rate</span>";
                        }
                        // added by archana for 0
                        if ($("#regCostRate" + i).val() != '' && $("#regSaleRate" + i).val() != '' && $("#regCostRate" + i).val() * 1 >= $("#regSaleRate" + i).val() * 1) {

                            console.log('condition 4 sale rate less than h');
                            this.isErorr = true;
                            $("#regSaleRate" + i).css("background", "#fd5c63");
                            this.rowBoxErrorMsg = "<span style='font-size: 24px !important;'>Either The Rates Are Missing or Sale Rate Is Less Than or Equal To The Cost Rate</span>";
                        }
                    }
                }

                if ($("#regHrs" + i).val() != '') {
                    console.log('checkErrorInAllRow regHrs if');
                    //if reg hrs value like 10:23:34
                    if ($("#regHrs" + i).val().includes(':')) {
                        if ($("#regHrs" + i).val().split(':')[1] > 59) {
                            this.isErorr = true;
                            this.rowBoxErrorMsg = "<span style='font-size: 24px !important;'>Reg Hrs Minute Can Not Be Greater Than 59 Minute</span>";
                            $("#regHrs" + i).css("background", "#fd5c63");
                        }
                        if ($("#regHrs" + i).val().split(':')[2] > 59) {
                            this.isErorr = true;
                            this.rowBoxErrorMsg = "<span style='font-size: 24px !important;'>Reg Hrs Second Can Not Be Greater Than 59 Second</span>";
                            $("#regHrs" + i).css("background", "#fd5c63");
                        }
                    }

                    //if reg cost rate is empty and existing reg rate is false
                    if ($("#regCostRate" + i).val() == '' && existingRegRateEmpty == true) {
                        console.log('condition 4 existing reg rate nahhhi h and cost rate blank h');
                        this.isErorr = true;
                        $("#regCostRate" + i).css("background", "#fd5c63");
                        this.rowBoxErrorMsg = "<span style='font-size: 24px !important;'>Either The Rates Are Missing or Sale Rate Is Less Than or Equal To The Cost Rate</span>";
                    }
                }

                console.log('checkErrorInAllRow otCostRate ', $("#otCostRate" + i).val());
                console.log('checkErrorInAllRow otSaleRate ', $("#otSaleRate" + i).val());
                console.log('checkErrorInAllRow existingOtRateEmpty ', existingOtRateEmpty);
                $("#otCostRate" + i).css("background", "");
                $("#otSaleRate" + i).css("background", "");
                //either sale rate or cost rate have value
                if ($("#otCostRate" + i).val() != '' || $("#otSaleRate" + i).val() != '') {
                    //true means existing rate is empty
                    if (existingOtRateEmpty == true) {
                        //if ot cost rate is empty and existing ot rate is false
                        if ($("#otCostRate" + i).val() == '' || $("#otCostRate" + i).val() * 1 <= 0) {
                            this.isErorr = true;
                            $("#otCostRate" + i).css("background", "#fd5c63");
                            this.rowBoxErrorMsg = "<span style='font-size: 24px !important;'>Either The Rates Are Missing or Sale Rate Is Less Than or Equal To The Cost Rate</span>";
                        }

                        //if ot cost rate have value and sale rate is empty and existing sale rate is false
                        if ($("#otCostRate" + i).val() != '' && ($("#otSaleRate" + i).val() == '' || $("#otSaleRate" + i).val() * 1 <= $("#otCostRate" + i).val() * 1)) {
                            this.isErorr = true;
                            $("#otSaleRate" + i).css("background", "#fd5c63");
                            this.rowBoxErrorMsg = "<span style='font-size: 24px !important;'>Either The Rates Are Missing or Sale Rate Is Less Than or Equal To The Cost Rate</span>";
                        }
                    } else {
                        //if ot cost rate have value and sale rate is empty and exiting sale rate is less than cost rate
                        if ($("#otCostRate" + i).val() != '' && $("#otSaleRate" + i).val() == '' && existingOtSaleRateValue * 1 <= $("#otCostRate" + i).val() * 1) {
                            this.isErorr = true;
                            $("#otSaleRate" + i).css("background", "#fd5c63");
                            this.rowBoxErrorMsg = "<span style='font-size: 24px !important;'>Either The Rates Are Missing or Sale Rate Is Less Than or Equal To The Cost Rate</span>";
                        }

                        //if ot sale rate have value and cost rate is empty and sale rate is less than exiting cost rate
                        if ($("#otCostRate" + i).val() == '' && $("#otSaleRate" + i).val() != '' && $("#otSaleRate" + i).val() * 1 <= existingOtCostRateValue * 1) {
                            this.isErorr = true;
                            $("#otSaleRate" + i).css("background", "#fd5c63");
                            this.rowBoxErrorMsg = "<span style='font-size: 24px !important;'>Either The Rates Are Missing or Sale Rate Is Less Than or Equal To The Cost Rate</span>";
                        }

                        if ($("#otCostRate" + i).val() != '' && $("#otCostRate" + i).val() * 1 <= 0) {
                            console.log('condition 3 existing reg rate h');
                            this.isErorr = true;
                            $("#otCostRate" + i).css("background", "#fd5c63");
                            this.rowBoxErrorMsg = "<span style='font-size: 24px !important;'>Either The Rates Are Missing or Sale Rate Is Less Than or Equal To The Cost Rate</span>";
                        }
                        // added by archana for 0
                        if ($("#otCostRate" + i).val() != '' && $("#otSaleRate" + i).val() != '' &&
                            $("#otCostRate" + i).val() * 1 >= $("#otSaleRate" + i).val() * 1) {
                            console.log('condition 4 ot sale rate less than h');
                            this.isErorr = true;
                            $("#otSaleRate" + i).css("background", "#fd5c63");
                            this.rowBoxErrorMsg = "<span style='font-size: 24px !important;'>Either The Rates Are Missing or Sale Rate Is Less Than or Equal To The Cost Rate</span>";
                        }
                    }
                }

                if ($("#otHrs" + i).val() != '') {
                    console.log('checkErrorInAllRow otHrs if');
                    //if ot hrs value like 10:23:34
                    if ($("#otHrs" + i).val().includes(':')) {
                        if ($("#otHrs" + i).val().split(':')[1] > 59) {
                            this.isErorr = true;
                            this.rowBoxErrorMsg = "<span style='font-size: 24px !important;'>Ot Hrs Minute Can Not Be Greater Than 59 Minute</span>";
                            $("#otHrs" + i).css("background", "#fd5c63");
                        }
                        if ($("#otHrs" + i).val().split(':')[2] > 59) {
                            this.isErorr = true;
                            this.rowBoxErrorMsg = "<span style='font-size: 24px !important;'>Ot Hrs Second Can Not Be Greater Than 59 Second</span>";
                            $("#otHrs" + i).css("background", "#fd5c63");
                        }
                    }

                    //if ot cost rate is empty and existing ot rate is false
                    if ($("#otCostRate" + i).val() == '' && existingOtRateEmpty == true) {
                        this.isErorr = true;
                        $("#otCostRate" + i).css("background", "#fd5c63");
                        this.rowBoxErrorMsg = "<span style='font-size: 24px !important;'>Either The Rates Are Missing or Sale Rate Is Less Than or Equal To The Cost Rate</span>";
                    }
                }

                console.log('checkErrorInAllRow dtCostRate ', $("#dtCostRate" + i).val());
                console.log('checkErrorInAllRow dtSaleRate ', $("#dtSaleRate" + i).val());
                console.log('checkErrorInAllRow existingDtRateEmpty ', existingDtRateEmpty);
                $("#dtCostRate" + i).css("background", "");
                $("#dtSaleRate" + i).css("background", "");
                //either sale rate or cost rate have value
                if ($("#dtCostRate" + i).val() != '' || $("#dtSaleRate" + i).val() != '') {
                    //true means existing rate is empty
                    if (existingDtRateEmpty == true) {
                        //if dt cost rate is empty
                        if ($("#dtCostRate" + i).val() == '' || $("#dtCostRate" + i).val() * 1 <= 0) {
                            this.isErorr = true;
                            $("#dtCostRate" + i).css("background", "#fd5c63");
                            this.rowBoxErrorMsg = "<span style='font-size: 24px !important;'>Either The Rates Are Missing or Sale Rate Is Less Than or Equal To The Cost Rate</span>";
                        }

                        //if dt cost rate have value and sale rate is empty or sale rate is less than cost rate
                        if ($("#dtCostRate" + i).val() != '' && ($("#dtSaleRate" + i).val() == '' || $("#dtSaleRate" + i).val() * 1 <= $("#dtCostRate" + i).val() * 1)) {
                            this.isErorr = true;
                            $("#dtSaleRate" + i).css("background", "#fd5c63");
                            this.rowBoxErrorMsg = "<span style='font-size: 24px !important;'>Either The Rates Are Missing or Sale Rate Is Less Than or Equal To The Cost Rate</span>";
                        }
                    } else {
                        //if dt cost rate have value and sale rate is empty and exiting sale rate is less than cost rate
                        if ($("#dtCostRate" + i).val() != '' && $("#dtSaleRate" + i).val() == '' && existingDtSaleRateValue * 1 <= $("#dtCostRate" + i).val() * 1) {
                            this.isErorr = true;
                            $("#dtSaleRate" + i).css("background", "#fd5c63");
                            this.rowBoxErrorMsg = "<span style='font-size: 24px !important;'>Either The Rates Are Missing or Sale Rate Is Less Than or Equal To The Cost Rate</span>";
                        }

                        //if dt sale rate have value and cost rate is empty and sale rate is less than exiting cost rate
                        if ($("#dtCostRate" + i).val() == '' && $("#dtSaleRate" + i).val() != '' && $("#dtSaleRate" + i).val() * 1 <= existingDtCostRateValue * 1) {
                            this.isErorr = true;
                            $("#dtSaleRate" + i).css("background", "#fd5c63");
                            this.rowBoxErrorMsg = "<span style='font-size: 24px !important;'>Either The Rates Are Missing or Sale Rate Is Less Than or Equal To The Cost Rate</span>";
                        }

                        if ($("#dtCostRate" + i).val() != '' && $("#dtCostRate" + i).val() * 1 <= 0) {
                            console.log('condition 3 existing reg rate h');
                            this.isErorr = true;
                            $("#dtCostRate" + i).css("background", "#fd5c63");
                            this.rowBoxErrorMsg = "<span style='font-size: 24px !important;'>Either The Rates Are Missing or Sale Rate Is Less Than or Equal To The Cost Rate</span>";
                        }

                        // added by archana for 0
                        if ($("#dtCostRate" + i).val() != '' && $("#dtSaleRate" + i).val() != '' && $("#dtCostRate" + i).val() * 1 >= $("#dtSaleRate" + i).val() * 1) {
                            console.log('condition 4 ot sale rate less than h');
                            this.isErorr = true;
                            $("#dtSaleRate" + i).css("background", "#fd5c63");
                            this.rowBoxErrorMsg = "<span style='font-size: 24px !important;'>Either The Rates Are Missing or Sale Rate Is Less Than or Equal To The Cost Rate</span>";
                        }
                    }
                }

                if ($("#dtHrs" + i).val() != '') {
                    console.log('checkErrorInAllRow dtHrs if');
                    //if dt hrs value like 10:23:34
                    if ($("#dtHrs" + i).val().includes(':')) {
                        if ($("#dtHrs" + i).val().split(':')[1] > 59) {
                            this.isErorr = true;
                            this.rowBoxErrorMsg = "<span style='font-size: 24px !important;'>Dt Hrs Minute Can Not Be Greater Than 59 Minute</span>";
                            $("#dtHrs" + i).css("background", "#fd5c63");
                        }
                        if ($("#dtHrs" + i).val().split(':')[2] > 59) {
                            this.isErorr = true;
                            this.rowBoxErrorMsg = "<span style='font-size: 24px !important;'>Dt Hrs Second Can Not Be Greater Than 59 Second</span>";
                            $("#dtHrs" + i).css("background", "#fd5c63");
                        }
                    }

                    //if dt cost rate is empty and existing dt rate is false
                    if ($("#dtCostRate" + i).val() == '' && existingDtRateEmpty == true) {
                        this.isErorr = true;
                        $("#dtCostRate" + i).css("background", "#fd5c63");
                        this.rowBoxErrorMsg = "<span style='font-size: 24px !important;'>Either The Rates Are Missing or Sale Rate Is Less Than or Equal To The Cost Rate</span>";
                    }
                }

                console.log('onkeyup this.isErorr ', this.isErorr);
            }
        }
    }

    // Delete the import data when click on cancel by archana 06/03/2023
    DeleteImport() {
        // var encrypted = this.EncrDecr.set(localStorage.getItem('key'), customer_id);
        const data = {
            APIKEY: this.APIKEY,
            user_id: this.user_id,
            company_id: this.company_id,
            status: 'Active',
            customer_id: this.customer_id,
            mobnumber: this.MobNumber
        };

        this._professional.DeleteProInfoForImport(data)
            .subscribe(
                res => {
                    if (res.status == true) {
                        this._router.navigate(["/mobile/edit-mobile/" + this.folder_id_e]);
                    } else {
                        this.toastr.error('Something went wrong');
                        return;
                    }
                },
            );
    }

    //click on upload button after file select
    openModal(template: TemplateRef<any>) {
        const inputFileValue = $("#inputFile").val();
        if (inputFileValue) {
            this.modalRef = this.modalService.show(template, this.config);
        } else {
            this.toastr.error('Please Select Any Xlsx File');
            return;
        }
    }

    // for open mapping modal
    openModalBtn() {
        this.modalRef.hide();
        const inputFileValue = $("#inputFile").val();
        if (inputFileValue) {
            this.display = 'block';
            if (this.fieldrecodes[0] == "Date Work Week" && this.fieldrecodes[1] == "Professional ID" && this.fieldrecodes[2] == "Name" && this.fieldrecodes[3] == "Site" && this.fieldrecodes[4] == "Speciality" && this.fieldrecodes[5] == "Reg Sale Rate" && this.fieldrecodes[6] == "Reg Cost Rate" && this.fieldrecodes[7] == "OT Sale Rate" && this.fieldrecodes[8] == "OT Cost Rate" && this.fieldrecodes[9] == "OT Sale Rate" && this.fieldrecodes[10] == "OT Cost Rate" && this.fieldrecodes[11] == "Reg Hrs" && this.fieldrecodes[12] == "OT Hrs" && this.fieldrecodes[13] == "DT Hrs" && this.fieldrecodes[14] == "Other Hrs") {
                this.btnDisableForMapping = false;
            } else {
                this.func(0);
            }
        }
        else {
            this.toastr.error('Please Select Any Xlsx File');
            return;
        }
    }
    // close mapping modal
    onCloseHandled(event) {
        if (event == 0) {
            this.modalRef.hide();
            this.display = 'none';
        } else {
            this.display = 'none';
            this.modalRef.hide();
            $("#inputFile").val('');
            this.ngOnInit();
        }
        this.selected_array = [];
        this.changetemplate = false;
    }

    // click on confirm button in mapping modal of xlsx file 
    onSubmit() {
        this.loaderMode = true;
        this.changetemplate = false;
        const select_fact_array = [];
        const datasrray = [];
        $(".checkImageAllOpn").each(function () {
            datasrray.push($(this).val());
            // added by archana for new headers
            if ($(this).val() == 'Date Work Week') {
                select_fact_array.push('Date_w_e');
            }
            if ($(this).val() == 'Professional ID') {
                select_fact_array.push('Assignment_No');
            }
            if ($(this).val() == 'Speciality') {
                select_fact_array.push('Department');
            }
            if ($(this).val() == 'Name') {
                select_fact_array.push('Name');
            }
            if ($(this).val() == 'Reg Hrs') {
                select_fact_array.push('Reg_Hrs');
            }
            if ($(this).val() == 'OT Hrs') {
                select_fact_array.push('OT_Hrs');
            }
            if ($(this).val() == 'DT Hrs') {
                select_fact_array.push('DT_Hrs');
            }
            if ($(this).val() == 'Other Hrs') {
                select_fact_array.push('Other_Hrs');
            }
            if ($(this).val() == 'Reg Sale Rate') {
                select_fact_array.push('Avg_Bill_Rate');
            }
            if ($(this).val() == 'Reg Cost Rate') {
                select_fact_array.push('Avg_Pay_Rate');
            }
            if ($(this).val() == 'OT Sale Rate') {
                select_fact_array.push('OT_Bill_Rate');
            }
            if ($(this).val() == 'OT Cost Rate') {
                select_fact_array.push('OT_Pay_Rate');
            }
            if ($(this).val() == 'DT Sale Rate') {
                select_fact_array.push('DT_Bill_Rate');
            }
            if ($(this).val() == 'DT Cost Rate') {
                select_fact_array.push('DT_Pay_Rate');
            }
            if ($(this).val() == 'Unknown') {
                select_fact_array.push('Unknown');
            }
            if ($(this).val() == 'Select') {
                select_fact_array.push('Select');
            }
            if ($(this).val() == 'Note') {
                select_fact_array.push('Note');
            }
            // end
        });

        this.datajsonForTemplate = datasrray;
        this.checkarray = select_fact_array;
        var res: any = select_fact_array.filter(u => u != 'Select');
        if (res.length >= 2) {
            var res1: any = res.filter(u1 => u1 != 'Unknown');
            var count = 0;
            res1.forEach(element => {
                if (element == 'Assignment_No') {
                    count++;
                }
                if (element == 'Department') {
                    count++;
                }
            });
            if (count >= 2) {
                this.selected_array = res1;
                this.btnDisableForMapping = false;
            } else {
                this.selected_array = [];
                this.btnDisableForMapping = true;
            }
        }
        if (this.selected_array.includes('Select') == true) {
            alert("Please Select All Options In Match Data Field");
        } else {
            var duplicates = this.selected_array.reduce(function (acc, el, i, arr) {
                if (arr.indexOf(el) !== i && acc.indexOf(el) < 0) acc.push(el); return acc;
            }, []);

            if (duplicates.length > 0) {
                const filteredArray = this.datajsonForTemplate.filter((item) => item !== 'Select' && item !== 'Unknown');
                var duplicatesName = filteredArray.reduce(function (acc, el, i, arr) {
                    if (arr.indexOf(el) !== i && acc.indexOf(el) < 0) acc.push(el); return acc;
                }, []);
                var str = '';
                for (let i = 0; i < duplicatesName.length; i++) {
                    str += (i + 1) + '.' + duplicatesName[i] + ', \n';
                }
                var answer = str.replace(/,\s*$/, "");
                var msg = 'You have selected duplicate records \n' + answer;
                alert(msg);
            } else {
                if (!this.hasDuplicates(this.selected_array)) {
                    var dataArray = this.createCustomeXlsxFun(this.checkarray, this.filelist);
                    if (dataArray == false) {
                        // alert('You have selected the wrong data for import');
                        setTimeout(() => {
                            this.loaderMode = false;
                        }, 1000);
                        this.onCloseHandled(0);
                        $("#inputFile").val('');
                    } else {
                        this.onCloseHandled(0);
                        console.log('dataArray ', dataArray);
                        this.showFileData(dataArray, true, false); //isRunShowDivFun is true,insertImportProfessionalIds is false
                        setTimeout(() => {
                            this.loaderMode = false;
                            if ($("#inputFile").val() == '') {
                                this.disableUploadBtn = true;
                            }
                        }, 1000);
                    }
                }
            }
        }
    }

    hasDuplicates(array) {
        return (new Set(array)).size !== array.length;
    }

    // modified by archana and commented by archana on 26/07/2023
    createCustomeXlsxFun(customheaders, arraylist) {
        // Custom headers to push in the new created array list
        var headerArr = [];
        for (let i = 0; i < customheaders.length; i++) {
            var dynamicVar = customheaders[i];
            headerArr.push(dynamicVar);
        }

        // To create a mapped data array with custom headers
        let data = [];
        let skippedRows = 0; // Initialize a variable to count skipped rows
        for (let i = 0; i < arraylist.length; i++) {
            var arr = arraylist[i];
            var val = {};
            let shouldSkipRow = false; // Add this variable to control skipping rows
            // Data of array list index loop
            let invalidDate = false;
            for (const key in arr) {
                const value = arr[key];
                var a: any = `${key}`;
                var b: any = `${value}`;
                for (let j = 0; j < this.fieldrecodes.length; j++) {
                    if (a == this.fieldrecodes[j]) {
                        b = b.trim();
                        var date1: any = '';
                        if (headerArr[j] == 'Date_w_e') {
                            if (b.includes('-') === true || b.includes('/') === true) {
                                date1 = new Date(b);
                                if (date1 == 'Invalid Date') {
                                    shouldSkipRow = true; // Skip the row if date is invalid
                                    invalidDate = true;
                                } else {
                                    const regexExp = /^(?:(?:(?:0?[1-9]|[12]\d|3[01])(\/|-)(?:0?[13578]|1[02])|(?:0?[1-9]|[12]\d|30)(\/|-)(?:0?[469]|11)|(?:0?[1-9]|1\d|2[0-8])(\/|-)0?2)(\/|-)\d{4})$|^(?:(?:0?[13578]|1[02])(\/|-)(?:0?[1-9]|[12]\d|3[01])|(?:0?[469]|11)(\/|-)(?:0?[1-9]|[12]\d|30)|0?2(\/|-)(?:0?[1-9]|1\d|2[0-8]))(\/|-)\d{4}$/;
                                    if (!regexExp.test(b)) {
                                        shouldSkipRow = true; // Skip the row if date format is invalid
                                        invalidDate = true;
                                    }
                                }
                            } else {
                                shouldSkipRow = true; // Skip the row if date format is invalid
                                invalidDate = true;
                            }
                        }
                        if (headerArr[j] == 'Avg_Bill_Rate' || headerArr[j] == 'Avg_Pay_Rate' || headerArr[j] == 'OT_Bill_Rate' || headerArr[j] == 'OT_Pay_Rate' || headerArr[j] == 'DT_Bill_Rate' || headerArr[j] == 'DT_Pay_Rate') {
                            if (typeof b === "string") {
                                // This block will execute if myString is a string
                                const replacedString = b.replace(/[\$,]/g, '');
                                b = replacedString;
                            }
                            if (isNaN(b)) {
                                b = '';
                            }
                        }
                        if (!shouldSkipRow) {
                            val[this.checkarray[j]] = b;
                        }
                    }
                }
            }
            if (!shouldSkipRow) {
                const obj = val;
                if ('Assignment_No' in obj || 'Department' in obj) {
                    // Both keys ('Name' and 'Reg_Hrs') are present in the object
                    console.log(val);
                    data.push(val); // Only add the row if shouldSkipRow is false
                } else {
                    // At least one of the keys is missing
                    skippedRows++; // Increment skipped row count
                }
            } else {
                skippedRows++; // Increment skipped row count
            }
        }

        // Show an alert with skipped and accepted row counts
        var confirmBox = confirm(`There are ${arraylist.length} rows found out of which ${data.length} rows are valid and ${skippedRows} rows  invalid.\n Do you want to import valid data?`);
        console.log(data);
        if (confirmBox == true) {
            return data;  // Mapped data end
        }
        else {
            return false;
        }

    }

    func($event) {
        const select_fact_array = [];
        const datasrray = [];
        $(".checkImageAllOpn").each(function () {
            datasrray.push($(this).val());
            // added by archana for new headers
            if ($(this).val() == 'Date Work Week') {
                select_fact_array.push('Date_w_e');
            }
            if ($(this).val() == 'Professional ID') {
                select_fact_array.push('Assignment_No');
            }
            if ($(this).val() == 'Speciality') {
                select_fact_array.push('Department');
            }
            if ($(this).val() == 'Name') {
                select_fact_array.push('Name');
            }
            if ($(this).val() == 'Reg Hrs') {
                select_fact_array.push('Reg_Hrs');
            }
            if ($(this).val() == 'OT Hrs') {
                select_fact_array.push('OT_Hrs');
            }
            if ($(this).val() == 'DT Hrs') {
                select_fact_array.push('DT_Hrs');
            }
            if ($(this).val() == 'Other Hrs') {
                select_fact_array.push('Other_Hrs');
            }
            if ($(this).val() == 'Reg Sale Rate') {
                select_fact_array.push('Avg_Bill_Rate');
            }
            if ($(this).val() == 'Reg Cost Rate') {
                select_fact_array.push('Avg_Pay_Rate');
            }
            if ($(this).val() == 'OT Sale Rate') {
                select_fact_array.push('OT_Bill_Rate');
            }
            if ($(this).val() == 'OT Cost Rate') {
                select_fact_array.push('OT_Pay_Rate');
            }
            if ($(this).val() == 'DT Sale Rate') {
                select_fact_array.push('DT_Bill_Rate');
            }
            if ($(this).val() == 'DT Cost Rate') {
                select_fact_array.push('DT_Pay_Rate');
            }
            if ($(this).val() == 'Unknown') {
                select_fact_array.push('Unknown');
            }
            if ($(this).val() == 'Select') {
                select_fact_array.push('Select');
            }
            if ($(this).val() == 'Note') {
                select_fact_array.push('Note');
            }
            // end
        });
        this.datajsonForTemplate = datasrray;
        this.checkarray = select_fact_array;

        var res: any = select_fact_array.filter(u => u != 'Select');
        if (res.length >= 2) {
            var res1: any = res.filter(u1 => u1 != 'Unknown');
            var count = 0;
            res1.forEach(element => {
                if (element == 'Assignment_No') {
                    count++;
                }
                if (element == 'Department') {
                    count++;
                }
            });

            if (count >= 2) {
                this.selected_array = res1;
                this.btnDisableForMapping = false;
            } else {
                this.selected_array = [];
                this.btnDisableForMapping = true;
            }
        }
        var duplicates = this.selected_array.reduce(function (acc, el, i, arr) {
            if (arr.indexOf(el) !== i && acc.indexOf(el) < 0) acc.push(el); return acc;
        }, []);

        if (duplicates.length > 0) {
            const filteredArray = this.datajsonForTemplate.filter((item) => item !== 'Select' && item !== 'Unknown');
            var duplicatesName = filteredArray.reduce(function (acc, el, i, arr) {
                if (arr.indexOf(el) !== i && acc.indexOf(el) < 0) acc.push(el); return acc;
            }, []);
            var str = '';
            for (let i = 0; i < duplicatesName.length; i++) {
                str += (i + 1) + '.' + duplicatesName[i] + ', \n';
            }
            var answer = str.replace(/,\s*$/, "");

            var msg = 'You have selected duplicate records \n' + answer;
            alert(msg);
        } else {
            if ($event != 0) {
                this.changetemplate = true;
            } else {
                this.changetemplate = false;
            }
        }
    }

    //////get folder details
    getFolderInfo(folderid) {
        this.loaderMode = true;
        const folderModel = {
            APIKEY: this.APIKEY,
            user_id: this.user_id,
            company_id: this.company_id,
            mobile_id: folderid,
        }
        this._soaImage.getFolderInfo(folderModel).subscribe(
            res => {
                this.showCustomerName = res.data.company_name;
                this.loaderMode = false;
            }, err => {
                this.loaderMode = false;
                console.log(err);
            }
        );
    }
    ////end

    onCancelPopUp() {
        this.modalRef.hide();
        if (localStorage.getItem('MobNumber') !== null) {
            localStorage.removeItem('MobNumber');
        }
        if (localStorage.getItem('importsuccess') !== null) {
            localStorage.removeItem('importsuccess');
        }
        if (localStorage.getItem('customer_id') !== null) {
            localStorage.removeItem('customer_id');
        }
        this._router.navigate(["/mobile/edit-mobile/" + this.folder_id_e]);
    }

    // check template exist on 27/march/2023
    checkTemplateExistance(header) {
        this.loaderMode = true;
        var duplicates = this.selected_array.reduce(function (acc, el, i, arr) {
            if (arr.indexOf(el) !== i && acc.indexOf(el) < 0) acc.push(el); return acc;
        }, []);

        if (duplicates.length > 0) {
            const filteredArray = this.datajsonForTemplate.filter((item) => item !== 'Select' && item !== 'Unknown');
            var duplicatesName = filteredArray.reduce(function (acc, el, i, arr) {
                if (arr.indexOf(el) !== i && acc.indexOf(el) < 0) acc.push(el); return acc;
            }, []);
            var str = '';
            for (let i = 0; i < duplicatesName.length; i++) {
                str += (i + 1) + '.' + duplicatesName[i] + ', \n';
            }
            var answer = str.replace(/,\s*$/, "");
            var msg = 'You have selected duplicate records \n' + answer;
            alert(msg);
        } else
        // return false;
        // the old code that needs to be run with this validation
        {
            // for database check the template exists and get all data of company
            var data = {
                APIKEY: this.APIKEY,
                customer_id: this.customer_id,
                company_id: this.company_id,
            };
            this._professional.getTemplateInfoForImport(data)
                .subscribe(
                    res => {
                        if (res.status == true) {
                            this.existingTemplate = [];
                            var tempData = res.data;
                            this.checkArrayStatus = false;
                            // // to check how many templates exist
                            tempData.forEach(element => {
                                var template_name: any = JSON.parse(element.template_name);
                                if (header.length == template_name.length) {
                                    this.checkArrayStatus = true;
                                    var count = 0;
                                    for (let i = 0; i < header.length; i++) {
                                        if (template_name[i] != header[i]) {
                                            count++;
                                        }
                                    }
                                }
                                // if headers match
                                if (this.checkArrayStatus == true) {
                                    if (count == 0) {
                                        // create custome headers of both array template match
                                        if (element.headers != null && element.xlsx_header_check != null) {
                                            var tempheader: any = JSON.parse(element.template_name);
                                            var tempheader1: any = JSON.parse(element.headers);
                                            var mergedArray = tempheader.map((e, i) => [e, tempheader1[i]]);
                                            var mergedArrayNew = mergedArray;
                                            mergedArray.forEach((merge, index) => {
                                                if (merge[1] == 'Select') {
                                                    const indexToRemove = index;
                                                    mergedArrayNew.splice(indexToRemove, 1);
                                                }
                                            });
                                            this.listdata.forEach((list, index) => {
                                                mergedArrayNew.forEach(merged => {
                                                    if (list[1] == merged[1]) {
                                                        this.listdata.splice(index, 1, merged)
                                                    }
                                                });
                                            });
                                            this.existingTemplate = element;
                                        }
                                        // both array created
                                    }
                                }
                                // end headers match
                            });
                        } else {
                            this.toastr.error('Something went wrong');
                            return;
                        }
                        this.loaderMode = false;
                    },
                    err => {
                        this.loaderMode = false;
                        console.log(err);
                    }
                );
            if (this.changetemplate == true) {
                if (this.checkArrayStatus == true && this.existingTemplate.length != 0) {
                    $('#updateTemplateInfoswal').click();
                } else {
                    $('#saveTemplateInfoswal').click();
                }
            }
        }
    }

    // api for template save creqated by archana
    templateSaveFunctionForMapping() {
        this.loaderMode = true;
        var datajsonForTemplatejson: any = JSON.stringify(this.datajsonForTemplate);
        var fieldrecodesjson: any = JSON.stringify(this.fieldrecodes);
        var checkarrayjson: any = JSON.stringify(this.checkarray);
        const xlsxModel = {
            APIKEY: this.APIKEY,
            customer_id: this.customer_id,
            company_id: this.company_id,
            headers: datajsonForTemplatejson,
            template_name: fieldrecodesjson,
            xlsx_header_check: checkarrayjson
        }
        this._professional.saveTemplateForMapping(xlsxModel).subscribe(
            res => {
                if (res.status == true) {
                    this.toastr.success('Template Saved Successfully');
                    // hide change template button
                    this.changetemplate = false;
                    this.loaderMode = false;
                    this.checkTemplateExistance(this.fieldrecodes);
                } else {
                    this.toastr.error('Something went wrong');
                }
            },
        );
    }
    // end
    // check headers match and run the template exist
    checkHeadersMatch(headers) {
        var count = 0;
        var Checkdata: any = ["Date Work Week", "Professional ID", "Name", "Speciality", "Reg Hrs", "OT Hrs", "DT Hrs", "Reg Cost Rate", "Reg Sale Rate", "OT Cost Rate", "OT Sale Rate", "DT Cost Rate", "DT Sale Rate,Note"];

        Checkdata.forEach(element => {
            if (headers.includes(element) == true) {
                count++;
            } else {
                count = 0;
            }
        });
        if (Checkdata.length != count) {
            this.checkTemplateExistance(headers);
        }
    }
    // update the template archana 30/03/2023
    templateUpdateFunctionForMapping() {
        var datajsonForTemplatejson: any = JSON.stringify(this.datajsonForTemplate);
        var fieldrecodesjson: any = JSON.stringify(this.fieldrecodes);
        var checkarrayjson: any = JSON.stringify(this.checkarray);
        var array1 = this.existingTemplate['template_name'];

        // to check if the template matches correctly
        const areEqual = array1 === fieldrecodesjson;

        // if template match
        if (areEqual == true) {
            this.loaderMode = true;
            const xlsxModel = {
                APIKEY: this.APIKEY,
                customer_id: this.customer_id,
                company_id: this.company_id,
                headers: datajsonForTemplatejson,
                template_name: fieldrecodesjson,
                xlsx_header_check: checkarrayjson,
                template_id: this.existingTemplate['id']
            }
            this._professional.updateTemplateForMapping(xlsxModel).subscribe(
                res => {
                    if (res.status == true) {
                        this.toastr.success('Template Updated Successfully');
                        // hide change template button
                        this.changetemplate = false;
                        this.loaderMode = false;
                        this.checkTemplateExistance(this.fieldrecodes);
                    } else {
                        this.toastr.error('Something went wrong');
                    }
                },
            );
        }
    }

    //this is for reg, ot and dt hrs input field
    onlynumeric(evt) {
        var ASCIICode = (evt.which) ? evt.which : evt.keyCode
        console.log('ASCIICode ', ASCIICode);
        if ((ASCIICode >= 48 && ASCIICode <= 58) || ASCIICode == 46) {
            return true;
        } else {
            return false;
        }

    }
}